import React, { createContext, useContext, useCallback } from 'react';
export var CustomNotificationContext = createContext({
    notifications: [],
    removeNotification: function () { return null; },
});
CustomNotificationContext.displayName = 'CustomNotificationContext';
export var CustomNotificationProvider = function (_a) {
    var children = _a.children, notifications = _a.notifications, removeNotification = _a.removeNotification, queueName = _a.queueName;
    var remove = useCallback(function (id) { return removeNotification(queueName, id); }, [
        queueName,
        removeNotification,
    ]);
    return (React.createElement(CustomNotificationContext.Provider, { value: {
            notifications: notifications,
            removeNotification: remove,
        } }, children));
};
export function useCustomNotifications(notificationTypes) {
    var _a = useContext(CustomNotificationContext), _b = _a.notifications, notifications = _b === void 0 ? [] : _b, removeNotification = _a.removeNotification;
    var filteredNotifications = notificationTypes
        ? notifications.filter(function (item) { return notificationTypes.includes(item.type); })
        : notifications;
    return { notifications: filteredNotifications, removeNotification: removeNotification };
}
//# sourceMappingURL=CustomNotificationContext.js.map